module.exports = __webpack_public_path__ + "static/Dinner 2018-4e5504ff4a7bc44f39415a7bbf975486.jpg";